<!--
Created on Fri Jun 16 2023

Copyright (c) Cynnox, Inc - All Rights Reserved 2023 Jagan

Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, September 2020.
-->

<div style="padding: 24px">
  @if (submitted) {
    <div>
      <div style="display: flex; align-items: center; flex-direction: column">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          style="height: 80px; width: 80px; fill: green"
          >
          <title>check-decagram</title>
          <path
            d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z"
            />
        </svg>
        <h4 style="font-family: Oswald, sans-serif !important">Success!</h4>
      </div>
      <p>
        Your request for the callback has been submitted. You will get a call from
        our team shortly.
      </p>
      <div style="display: flex; justify-content: end">
        <button
          [disabled]="loading"
          type="submit"
          class="btn btn-primary text-light"
        style="
          cursor: pointer;
          background-color: #004777 !important;
          width: 165px;
          border-color: #004777 !important;
          outline: none;
        "
          (click)="onClickClose()"
          >
          <span>Close</span>
        </button>
      </div>
    </div>
  }

  @if (!submitted) {
    <div class="form-container">
      <div class="headerSection">
        <h3 style="display: contents; font-family: Oswald, sans-serif !important">
          Contact Us
        </h3>
        <div class="closeBtn" (click)="onClickClose()">
          <ion-icon
            name="close-outline"
            style="font-size: 25px; cursor: pointer; pointer-events: none"
          ></ion-icon>
        </div>
      </div>
      <div style="background-color: #f5f5f5; border-radius: 5px; padding: 8px">
        <div class="form-group">
          <label for="firstName" style="font-weight: 600"
            >First Name <span style="color: #dc3545">*</span></label
            >
            <input
              class="form-control"
              type="text"
              name="firstName"
              maxlength="60"
              autocomplete="off"
              [(ngModel)]="firstName"
              placeholder="Enter your first name"
              required
          [ngClass]="{
            'is-invalid': firstNameErrorMsg
          }"
              (input)="firstNameErrorMsg = ''"
              />
            <div style="color: #dc3545">{{ firstNameErrorMsg }}</div>
          </div>
          <div class="form-group">
            <label for="lastName" style="font-weight: 600">Last Name</label>
            <input
              class="form-control"
              type="text"
              name="lastName"
              maxlength="60"
              autocomplete="off"
              [(ngModel)]="lastName"
              placeholder="Enter your last name"
              required
              />
          </div>
          <div class="form-group">
            <label for="phone" style="font-weight: 600"
              >Phone Number <span style="color: #dc3545">*</span></label
              >
              <div style="display: flex">
                <div
                  style="position: relative; width: 90px"
                  [matMenuTriggerFor]="navListMenu"
                  >
                  <input
                    type="text"
                    class="form-control"
                    name="countrycode"
                    [(ngModel)]="countrycode"
                    required
                    style="cursor: pointer"
                    />
                  <div class="iconContainer">
                    <ion-icon name="chevron-down-outline"></ion-icon>
                    <mat-menu
                      #navListMenu="matMenu"
                      xPosition="before"
                      class="custom_scrollbar"
                      >
                      @for (x of countryCodes; track x) {
                        <li
                          mat-menu-item
                          [value]="x.code"
                          (click)="selectValue(x)"
                          >
                          {{ x.country }}
                        </li>
                      }
                    </mat-menu>
                  </div>
                </div>
                <input
                  type="number"
                  class="form-control"
                  name="phone"
                  autocomplete="off"
                  placeholder="Enter your phone number"
                  [(ngModel)]="phoneNumber"
            [ngClass]="{
              'is-invalid': phoneNumberErrorMsg
            }"
                  required
                  (input)="phoneNumberErrorMsg = ''"
                  />
              </div>
              <div style="color: #dc3545">{{ phoneNumberErrorMsg }}</div>
            </div>
            <div class="form-group">
              <label for="email" style="font-weight: 600">Email</label>
              <input
                class="form-control"
                type="email"
                name="email"
                autocomplete="off"
                [(ngModel)]="email"
                placeholder="Enter your email"
                required
          [ngClass]="{
            'is-invalid': emailErrorMsg
          }"
                (input)="emailErrorMsg = ''"
                />
              <div style="color: #dc3545">{{ emailErrorMsg }}</div>
            </div>
            <div class="form-group">
              <label for="description" style="font-weight: 600">Question</label>
              <textarea
                name="description"
                class="form-control"
                rows="3"
                [(ngModel)]="description"
                placeholder="Write your question here.."
                style="max-height: 160px; resize: vertical"
              ></textarea>
              <div style="color: #dc3545">{{ descriptionErrorMsg }}</div>
            </div>
          </div>
          <div style="margin: 10px 0px 10px 0px; display: flex; justify-content: end">
            <button
              [disabled]="loading"
              type="submit"
              class="btn btn-primary text-light"
              [ngStyle]="{ cursor: loading ? 'no-drop' : 'pointer' }"
        style="
          background-color: #004777 !important;
          width: 165px;
          border-color: #004777 !important;
          outline: none;
        "
              (click)="onSubmit()"
              >
              @if (loading) {
                <i class="fa fa-spinner fa-spin"></i>
              }
              @if (!loading) {
                <span>Submit</span>
              }
            </button>
          </div>
        </div>
      }
    </div>
